import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ProductDefinitionGroupName } from '@nx-ws/bhn-enums/product/definitions/group-name.enum';

import { BaseDefinitionDto } from './../../shared/base-definition.dto';

@Injectable()
export class ProductDefinitionRestService {
  constructor(private http: HttpClient) {}

  // ToDo: use getList() as public method in components, get rid of all methods in ProductDefinitionService, which use getList();
  getList(groupName: ProductDefinitionGroupName) {
    const url = 'api/productManagement/definitions';
    const params = {
      groupName
    };

    return this.http.get<BaseDefinitionDto[]>(url, { params: params }).pipe(
      map(data => {
        return data
          .map(i => new BaseDefinitionDto(i))
          .filter(i => i.status !== 'DELETED');
      }),
      catchError(this.handleError)
    );
  }

  getProductLineTypes(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.PRODUCT_LINE_TYPE);
  }

  getType(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.PRODUCT_TYPE);
  }

  getCategory(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.CATEGORY);
  }

  getLegacyDistributionType(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.LEGACY_DISTRIBUTION_TYPE);
  }

  getProductCategories(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.CATEGORY);
  }

  getVariantCreationReasons(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.VARIANT_CREATION_REASON);
  }

  getFulfillmentProvisioningType(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.PROVISIONING_TYPE);
  }

  getDistributionChannels(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.DISTRIBUTION_CHANNEL_TYPE);
  }

  getRedemptionLocations(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.REDEMPTION_LOCATION);
  }

  getRedemptionMethods(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.REDEMPTION_METHOD);
  }

  getRedemptionPinLocations(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.REDEMPTION_PIN_LOCATION);
  }

  getRedemptionPinUseTypes(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.REDEMPTION_PIN_USE_TYPE);
  }

  getProcessingPaymentNetworks(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.PAYMENT_NETWORK);
  }

  getProcessingIssuerBanks(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.ISSUERBANK);
  }

  getProcessingActivationTypes(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.ACTIVATION_TYPE);
  }

  getExpirationTypes(): Observable<BaseDefinitionDto[]> {
    return this.getList(
      ProductDefinitionGroupName.PRODUCT_CARD_EXPIRATION_TYPE
    );
  }

  getCardPrintTypes(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.PRODUCT_CARD_PRINT_TYPE);
  }

  getReloadSystems(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.RELOAD_SYSTEM);
  }

  getPrimaryBalanceInquirySystems(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.BALANCE_INQUIRY_SYSTEM);
  }

  getSecondaryBalanceInquirySystems(): Observable<BaseDefinitionDto[]> {
    return this.getList(
      ProductDefinitionGroupName.SECONDARY_BALANCE_INQUIRY_SYSTEM
    );
  }

  getCodeTypes(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.PRODUCT_CODE_TYPE);
  }

  getSourceTypes(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.BUSINESS_SOURCE);
  }

  getEntityStates(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.ENTITY_STATE);
  }

  getPackagingPackTypes(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.PRODUCT_PACKTYPE);
  }

  getEnvironments(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.E_DESIGN_ENVIRONMENT_TYPE);
  }

  getPlanogramCategoryes(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.PLANOGRAM_CATEGORY);
  }

  getPlanogramSubCategoryes(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.PLANOGRAM_SUB_CATEGORY);
  }

  getPlanogramMainCategoryes(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.PLANOGRAM_MAIN_CATEGORY);
  }

  getPlanogramDetailsDimensions(): Observable<BaseDefinitionDto[]> {
    return this.getList(ProductDefinitionGroupName.PLANOGRAM_DIMENSION);
  }

  private handleError(errorResponse: any): Promise<any> {
    console.error('An error in ProductDefinitionRestService: ', errorResponse);
    return Promise.reject(errorResponse.error.errors);
  }
}
